'use client'

import { useEffect } from 'react'
import { datadogRum } from '@datadog/browser-rum'

let hasInitialized = false

interface DatadogRumInitProps {
  env: string
  version: string
}

export default function DatadogRumInit({ env, version }: DatadogRumInitProps) {
  useEffect(() => {
    if (hasInitialized) return

    const applicationId = process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID
    const clientToken = process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN

    if (!applicationId || !clientToken) return

    datadogRum.init({
      applicationId,
      clientToken,
      site: 'datadoghq.com',
      service: 'clinic',
      env,
      version,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 20,
      defaultPrivacyLevel: 'mask-user-input',
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true
    })

    hasInitialized = true
  }, [env, version])

  return null
}
